(function () {
    'use strict';
    angular.module('app').controller('assign', assign);
    assign.$inject = ['$location', '$scope', '$rootScope', 'gridDataService', '$q', 'SelectionCommand_WorkflowService', '$timeout', '$mdDialog', 'records', 'command', 'commandService', 'loginService', 'editEmailsService'];
    function assign($location, scope, $rootScope, gridDataService, $q, SelectionCommand_WorkflowService, $timeout, $mdDialog, records, command, commandService, loginService, editEmailsService) {
      
        // =====================================
        // On Load.
        // =====================================

        // Initialize.
        // PL-OBS? scope.assignDialogShown = false;
        scope.ACN_ASSIGN = 121;
        scope.ACN_UNASSIGN = 122;
        scope.xyz = { bReadyForOK: false };
        scope.processingLabel = loginService.resourceStrings["PROCESSING"];

        //var offset = new Date().getTimezoneOffset();
        //// js is backwards
        //if (offset > 0)
        //    offset = 0 - offset;
        //console.log('offset in minutes: ' + offset);
        //console.log('offset in hours: ' + offset / 60);

        // =====================================
        // On Load. Assign To.
        // =====================================
        // Set the combo to 'building list'.
        scope.qualifiedUsersArrayLoading = function () {
            // If already on the 'building list', just leave it.
            if (scope.xyz.selectedUserItem != scope.qualifiedUsersBuildingList) {
                // Clear the array.
                scope.qualifiedUsersArray = [];
                // Add 'building list' to the array.
                scope.qualifiedUsersArray.push(scope.qualifiedUsersBuildingList);
                // Select 'building list' in the combo.
                scope.xyz.selectedUserItem = scope.qualifiedUsersBuildingList;
                // We are waiting for the items.
                scope.xyz.gettingUserList = true;
            }
        };
        // Load items into the combo. May be null.
        scope.qualifiedUsersArrayLoad = function (users) {
            // Clear the array.
            scope.qualifiedUsersArray = [];
            // Add 'pick one'.
            scope.qualifiedUsersArray.push(scope.qualifiedUsersPickOne);
            // Select 'pick one'.
            scope.xyz.selectedUserItem = scope.qualifiedUsersPickOne;
            // Add ''.
            scope.qualifiedUsersArray.push(scope.qualifiedUsersBlank);
            // If there are items, ...
            if (users != null) {
                // Walk the items, ...
                angular.forEach(users, function (name, id) {
                    // Add the item to the array.
                    scope.qualifiedUsersArray.push({ id: id, name: name })
                });
            }
            // We are done getting the items.
            scope.xyz.gettingUserList = false;
        }
        // Create a 'building list' item.
        scope.qualifiedUsersBuildingList = { id: 'building_list', name: "- " + loginService.resourceStrings["COMBO_BOX_BUILDING_LIST"] + " -" };
        // Create a 'pick one' item.
        scope.qualifiedUsersPickOne = { id: 'pick_one', name: "- " + loginService.resourceStrings["COMBO_BOX_PICK_ONE"] + " -" };
        // Create a '' item.
        scope.qualifiedUsersBlank = { id: '', name: '' };
        // Initailize to the 'building list' state.
        scope.qualifiedUsersArrayLoading();

        // =====================================
        //
        // =====================================  

        // PL-OBS?
        //scope.$on('assignButtonClicked', function (event, arg) {
        //    scope.onAssignButtonClicked(arg.slx);
        //});
        //scope.$on('unassignButtonClicked', function (event, arg) {
        //    scope.onUnassignButtonClicked(arg.slx);
        //});

        //
        // On user change.
        //
        scope.selectedUserChanged = function () {
            // If nothing selected, then return.
            if (scope.xyz.selectedUserItem == null)
                return;
            // If user selected 'pick one', then return.
            if (scope.xyz.selectedUserItem == scope.qualifiedUsersPickOne)
                return;

            var nameForGrid = scope.xyz.selectedUserItem.name;
            // EDGE-EMPTY         
            if (scope.xyz.selectedUserItem.name.length < 1) {
                var browserInfo = navigator.userAgent;
                var bIsEdge = browserInfo.indexOf('Edge/') != -1;
                if (bIsEdge) {
                    // scope.xyz.selectedUserItem.name = '\u00A0';
                    nameForGrid = '\u00A0';
                }
            }
                       
            // Walk the grid's selected items.
            var len = scope.gridOptions.data.length;
            for (var i = 0; i < len; i++) {
                // Get this selected item.
                var gridItem = scope.gridOptions.data[i];
                if (gridItem.isSelected) {
                    gridItem.assignToId = scope.xyz.selectedUserItem.id;
                    gridItem.assignTo = nameForGrid; // scope.xyz.selectedUserItem.name;
                    gridItem.selectionItem.commandParams.eAssignToUserId = scope.xyz.selectedUserItem.id; // *****
                }
            }
            // Do Enables.
            scope.doEnables();
        };

        //
        // Enables.
        //
        scope.doEnables = function () {
            // Unassign has nothing to do but pick OK.
            if (scope.mode == scope.ACN_UNASSIGN)
                return;

            // Does every row have an assign-to user?
            var bAllHaveTarget = true;

            // Walk the grid's items.
            var len = scope.gridOptions.data.length;
            for (var i = 0; i < len; i++) {
                // Get this item.
                var gridItem = scope.gridOptions.data[i];
                // See if this row has an assign-to user.
                if (gridItem.assignToId.length < 1)
                    bAllHaveTarget = false;
            }

            // Handle enabling OK.
            scope.xyz.bReadyForOK = bAllHaveTarget;
        }

        scope.comboFocus = function (event) {
            event.target.options.selectedIndex = -1;
        }

        //
        // On selection changed in the grid.
        //
        scope.selectItem = function (item) {



            // Unassign has nothing to do but pick OK.
            if (scope.mode == scope.ACN_UNASSIGN)
                return;

            // Always set all items to not selected.
            angular.forEach(scope.gridOptions.data, function (item) {
                item.isSelected = false;
            });

            // Get the selected items.
            var items = [];
            angular.forEach(scope.gridApi.selection.getSelectedRows(), function (item) {
                item.isSelected = true;
                items.push(item.selectionItem);
            });

            // Build the SL with mode and order.
            var slx = { mode: 0, order: 0, list: items };

            // ============================
            // Select Item. Assign To.
            // ===========================+
            // Add users to the combo.
            scope.qualifiedUsersArrayLoading();
            if (items.length < 1) {
                scope.qualifiedUsersArrayLoad();
            }
            else {
                SelectionCommand_WorkflowService.GetUserListForAssign(slx, scope.ACN_ASSIGN).then(function (response) {
                    scope.qualifiedUsersArrayLoad(response.data);
                }, function () {
                    scope.qualifiedUsersArrayLoad();
                });
            }

            // Do Enables.
            scope.doEnables();
        };

        

        // On click of the Assign button.
        scope.onAssignButtonClicked = function (slx) {
            // scope
            scope.slx = slx;
            scope.mode = scope.ACN_ASSIGN;
            // PL-OBS? scope.xyz = { bReadyForOK: false, selectedUserItem: {} };

            scope.gridOptions.columnDefs = [{ name: 'Name', field: 'name', width: '33%', minWidth: '100' },
                { name: 'Library', field: 'library', width: '33%', minWidth: '100' },
                { name: 'Assign To', field: 'assignTo', width: '33%', minWidth: '100' }];

            // dialog config
            scope.heading = loginService.resourceStrings["ASSIGN"]; // "Assign";
            scope.filesLabel = loginService.resourceStrings["FILES_TO_ASSIGN"]; // "Files to Assign:";
            scope.assignToLabel = loginService.resourceStrings["ASSIGN_TO"]; // "Assign To:";
            scope.OK = loginService.resourceStrings["OK"]; // "OK";
            scope.Cancel = loginService.resourceStrings["CANCEL"]; // "Cancel";
            // dialog config columns
            scope.doColumns();

            // For each selection item, add a row to the grid.
            scope.gridOptions.data = [];
            var index = 0;
            angular.forEach(scope.slx.list, function (item) {
                // Add item.
                scope.gridOptions.data.push({
                    index: index,
                    selectionItem: item,
                    isSelected: true,
                    name: item.filename, library: item.detailedInfo.libName,
                    assignToId: "", assignTo: "",
                });
                index++;
            });

            // Enables.
            // PL-OBS? scope.selectItem();
            // Do modal.
            // PL-OBS? scope.assignDialogShown = true;
            $timeout(function () {
                refreshGrid();
                scope.gridApi.selection.selectAllRows();
                $timeout(function () {
                    refreshGrid();
                }, 2000);
            }, 500);
        };

        scope.onUnassignButtonClicked = function (slx) {
            // scope
            scope.slx = slx;
            scope.mode = scope.ACN_UNASSIGN;
            scope.xyz = { bReadyForOK: true }; // Unassign has nothing to do but pick OK.

            scope.gridOptions.columnDefs = [{ name: 'Name', field: 'name', width: '50%', minWidth: '100' },
                { name: 'Library', field: 'library', width: '50%', minWidth: '100' }];

            // dialog config
            scope.heading = loginService.resourceStrings["UNASSIGN"]; // "Unassign";
            scope.filesLabel = loginService.resourceStrings["FILES_TO_UNASSIGN"]; // "Files to Unassign:";
            scope.OK = loginService.resourceStrings["OK"]; // "OK";
            scope.Cancel = loginService.resourceStrings["CANCEL"]; // "Cancel";
            // dialog config columns
            scope.doColumns();

            // For each selection item, add a row to the grid.
            scope.gridOptions.data = [];
            var index = 0;
            angular.forEach(scope.slx.list, function (item) {
                scope.gridOptions.data.push({
                    index: index,
                    selectionItem: item,
                    isSelected: true,
                    name: item.filename, library: item.detailedInfo.libName,
                    assignToId: "", assignTo: "",
                });
                index++;
            });

            // do modal
            scope.assignDialogShown = true;
            $timeout(function () {
                refreshGrid();
                scope.gridApi.selection.selectAllRows();
                $timeout(function () {
                    refreshGrid();
                }, 2000);
            }, 500);
        }

        scope.doColumns = function () {
            // dialog config columns
            var colName = loginService.resourceStrings["SCHEMA_S_LONGNAME"];
            var colLibrary = loginService.resourceStrings["SCHEMA_S_LIBNAME"];
            var colAssignTo = loginService.resourceStrings["ASSIGN_TO"];
            scope.gridOptions.columnDefs[0].name = colName;
            scope.gridOptions.columnDefs[1].name = colLibrary;
            if (scope.gridOptions.columnDefs.length > 2)
                scope.gridOptions.columnDefs[2].name = colAssignTo;
        }

        scope.onDisableTest = function () {
            scope.xyz.processing = !scope.xyz.processing;
        }

        scope.onAssignDialogOK = function () {
            scope.xyz.processing = true;
            if (scope.mode == scope.ACN_ASSIGN) {
                // Execute.
                SelectionCommand_WorkflowService.Assign(scope.slx).then(function (response) {
                    // Handle errors.
                    var atLeastOneError = false;
                    var selectionCommandResults = response.data;
                    var slx = selectionCommandResults.slx;
                    angular.forEach(slx.list, function (item) {
                        if (atLeastOneError == false) {
                            if (item.ec != 0) {
                                atLeastOneError = true;
                                if (atLeastOneError) {
                                    commandService.launchErrors({ slx: slx });
                                }
                            }
                        }
                    });
                    // Close dialog and refresh grid.
                    $mdDialog.hide();
                    scope.xyz.processing = false;
                    gridDataService.updateGridRecords(slx.list);

                    editEmailsService.showEditEmailsDialog(selectionCommandResults.emails);
                }, function () {
                    scope.xyz.processing = false;
                });
            }
            else if (scope.mode = scope.ACN_UNASSIGN) {
                // Execute.
                SelectionCommand_WorkflowService.Unassign(scope.slx).then(function (response) {
                    // Handle errors.
                    var atLeastOneError = false;
                    var selectionCommandResults = response.data;
                    var slx = selectionCommandResults.slx;
                    angular.forEach(slx.list, function (item) {
                        if (atLeastOneError == false) {
                            if (item.ec != 0) {
                                atLeastOneError = true;
                                if (atLeastOneError) {
                                    commandService.launchErrors({ slx: slx });
                                }
                            }
                        }
                    });
                    // Close dialog and refresh grid.
                    $mdDialog.hide();
                    scope.xyz.processing = false;
                    gridDataService.updateGridRecords(slx.list);

                    editEmailsService.showEditEmailsDialog(selectionCommandResults.emails);
                }, function () {
                    scope.xyz.processing = false;
                });
            }
        };

        scope.onAssignDialogCancel = function () {
            // Close dialog.
            $mdDialog.hide();
        };

        scope.assignDialogClosed = function () {

        }

        var refreshGrid = function () {
            scope.gridApi.grid.handleWindowResize();
            scope.gridApi.grid.refreshCanvas();
            scope.gridApi.grid.refresh();
        }

        var onRegisterApi = function (gridApi) {
            scope.gridApi = gridApi;
            gridApi.selection.on.rowSelectionChanged(scope, scope.selectItem);
            gridApi.selection.on.rowSelectionChangedBatch(scope, scope.selectItem);

            //after the grid has been initialized
            switch (command) {
                case "assign":
                    scope.onAssignButtonClicked(records);
                    break;
                case "unassign":
                    scope.onUnassignButtonClicked(records);
                    break;
            }
           
        }

        scope.gridApi = {};

        scope.gridOptions = {
            data: [],
            enableSelectionBatchEvent: true,
            multiSelect: true,
            modifierKeysToMultiSelect: true,
            enableFullRowSelection: true,
            enableRowHeaderSelection: false,
            useExternalSorting: true,
            enableColumnMenus: false,
            enableColumnResizing: true,
            columnDefs: [
                { name: 'Name', field: 'name', width: '33%', minWidth: '100' },
                { name: 'Library', field: 'library', width: '33%', minWidth: '100' },
                { name: 'Assign To', field: 'assignTo', width: '33%', minWidth: '100' }],
            onRegisterApi: onRegisterApi
        }

        activate();

        function activate() { }
    }
})();
